import { css } from '@emotion/react';
import { createTheme } from '@mui/material/styles';

export const GlobalStyle = css`
  html {
    font-family: 'Urbanist', sans-serif;
    font-weight: 400;
    font-size: 1em;
  }

  body {
    /* Override MUI default CSSBaseline */
    background-color: transparent !important;
  }

  h1,
  h2,
  h4,
  header li {
    font-family: 'DM Serif Text', sans-serif;
    font-weight: 600;
    line-height: 1.21;
  }
  h1 {
    font-size: 2.5rem;
  }

  h2 {
    font-size: 2rem;
  }
  h3 {
    font-size: 1.5rem;
    font-weight: 300;
  }

  p,
  q,
  li {
    line-height: 1.61;
  }
  a {
    text-decoration: none;
    color: #001e61;
  }
  #submitBtn {
    background-color: #001e61 !important;
    color: #fff;
    height: auto !important;
    min-width: 110px !important;
    margin: 16px auto !important;
    text-align: center !important;
    line-height: 26px !important;
    border-radius: 26px !important;
    border: none !important;
    font-size: 11px !important;
    font-weight: 600 !important;
    letter-spacing: -0.01em;
    padding: 1px 16px 0px;
    :hover {
      cursor: pointer;
    }
  }
  #alt-msg {
    line-height: 1.61;
    text-align: center;
    padding: 10px;
  }
  input {
    font-size: 0.875em;
  }
  .MuiButtonBase-root {
    text-transform: none !important;
  }

  @media (max-width: 756px) {
    h1 {
      font-size: 26px;
    }
    h2,
    h3 {
      font-size: 18px;
    }
    h4 {
      font-size: 12px;
    }
    h1,
    h2,
    h3,
    h4,
    p,
    header {
      overflow: hidden;
      display: block;
    }
    p {
      font-size: 13px;
    }
  }
`;

const theme = createTheme({
  typography: {
    fontFamily: ['Urbanist', 'DM Serif Text', 'sans-serif'].join(','),
  },
  palette: {
    primary: {
      main: '#20275C',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#ff8300',
      contrastText: '#ffffff',
    },
  },
});

export default theme;
